export default "__VITE_ASSET__DiOaOzj1__"